var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CesiumIonAsset } from "./CesiumIonAsset";
import { KmlLoader } from "../../loaders/KmlLoader";
/**
 * A CesiumIonAsset specialization for handling KML assets
 */
export class CesiumIonKMLAsset extends CesiumIonAsset {
    /**
     *
     * @param endpoint
     */
    static fromEndpoint(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            // While apparently the REST docs allow these to be undefined, we require all 3 fields to be present. If they
            // aren't then we return undefined as we can't produce an asset otherwise
            if (typeof endpoint.type === "undefined" ||
                typeof endpoint.url === "undefined" ||
                typeof endpoint.accessToken === "undefined") {
                throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
            }
            return new CesiumIonKMLAsset(endpoint.url, endpoint.accessToken, endpoint.attributions);
        });
    }
    loadKml(glyphCache, cacheKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.url;
            return yield KmlLoader.load(url, {
                glyphCache,
                headers: {
                    Authorization: this.tokenHeaderValue,
                },
                cacheKey,
            });
        });
    }
}
